export default __webpack_public_path__ + "assets/677d5b2315790eb43546eac638b7c7dc.png";